import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const listNeeds = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/client-needs`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data; // { items, page, pageSize, totalItems, totalPages }
};

export const getNeed = async (needId, options = {}) => {
  const { buId, params } = options || {};
  const response = await axios.get(`${BASE_URL}/client-needs/${needId}`, {
    ...(params ? { params } : {}),
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const createNeed = async (payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/client-needs`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const updateNeed = async (needId, payload, options = {}) => {
  const { buId } = options || {};
  const response = await axios.patch(`${BASE_URL}/client-needs/${needId}`, payload, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const deleteNeed = async (needId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.delete(`${BASE_URL}/client-needs/${needId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const confirmDeleteNeed = async (needId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/client-needs/${needId}/confirm-delete`, null, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

// Add a comment to a client need
// POST /client-needs/{need_id}/comments body: { comment: "...", parentCommentId?: number|string }
export const addNeedComment = async (needId, comment, options = {}, parentCommentId) => {
  const { buId } = options || {};
  const response = await axios.post(
    `${BASE_URL}/client-needs/${needId}/comments`,
    { comment, ...(parentCommentId ? { parentCommentId } : {}) },
    {
      ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
    }
  );
  return response.data;
};

// Get comments for a client need (thread tree)
// GET /client-needs/{need_id}/comments
export const getNeedComments = async (needId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/client-needs/${needId}/comments`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data;
};

export const importNeedFromFile = async (file, clientId, options = {}) => {
  const { buId } = options || {};
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(`${BASE_URL}/client-needs/from-file`, formData, {
    params: { clientId },
    headers: { 
      "Content-Type": "multipart/form-data", 
      ...(buId ? { "X-Business-Unit-Id": buId } : {}) 
    }
  });
  return response.data;
};

// Import needs from CSV / Excel file
// Backend expects: POST /client-needs/import with "file" (CSV or .xlsx)
// Returns a NeedListResponse: { items, page, pageSize, totalItems, totalPages }
export const importNeedsFromFile = async (file, options = {}) => {
  const { buId } = options || {};
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(`${BASE_URL}/client-needs/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(buId ? { "X-Business-Unit-Id": buId } : {})
    }
  });
  return response.data;
};

// Download the 2-tab .xlsx template (Summary + Need) for the Needs import.
export const getNeedsImportTemplate = async (options = {}) => {
  const { buId, lang } = options || {};
  const response = await axios.get(`${BASE_URL}/client-needs/import/template`, {
    responseType: "blob",
    params: lang ? { lang } : undefined,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response;
};

// Download a client need's stored job-description file as a blob.
// Caller is responsible for reading `.data` (Blob) and `.headers` (e.g.
// content-disposition for the filename).
export const downloadNeedJobDescription = async (needId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/client-needs/${needId}/job-description`, {
    responseType: "blob",
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response;
};

export const listUsersInMyBusinessUnit = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/auth/users/in-my-business-unit`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {})
  });
  return response.data; // array of { id, email, first_name, last_name, role }
};

